import React from 'react';
import './App.css';
import MainContent from "./components/MainContent";
import BackgroundVideo from "./components/BackgroundVideo";

function App() {
  return (
    <div className="App">
      <MainContent/>
      <BackgroundVideo/>
    </div>
  );
}

export default App;
